const actions = {
    SET_STATE: 'posting/SET_STATE',
    GET_POSTING_AUTOCOMPLETE: 'posting/GET_POSTING_AUTOCOMPLETE',
    GET_PACKAGE_CATEGORY: 'posting/GET_PACKAGE_CATEGORY',
    GET_GL_ACCOUNT_CODE: 'posting/GET_GL_ACCOUNT_CODE', 
    REVERSAL: 'posting/REVERSAL',
    DELETE_STATEMENT_FILE: 'posting/DELETE_STATEMENT_FILE',
    GET_CLAIMED_PAYMENT: 'posting/GET_CLAIMED_PAYMENT',
    GET_STATEMENT_EXCEL: 'posting/GET_STATEMENT_EXCEL',
    GET_STATEMENT_UPLOAD_LIST: 'posting/GET_STATEMENT_UPLOAD_LIST',
    GET_STATEMENT_PER_UPLOAD: 'posting/GET_STATEMENT_PER_UPLOAD',
    GET_RELATED_PAYMENT: 'posting/GET_RELATED_PAYMENT',
    UPLOAD_STATEMENT_ACCOUNT: 'posting/UPLOAD_STATEMENT_ACCOUNT',
    GET_TARGET_LIST: 'posting/GET_TARGET_LIST',
    DISPLAY_POSTING_TABLE: 'posting/DISPLAY_POSTING_TABLE',
    SUBMIT_POSTING_RECORDS: 'posting/SUBMIT_POSTING_RECORDS',
    SUBMIT_POSTING: 'posting/SUBMIT_POSTING',
  }

  export default actions
